import styled, { css, keyframes } from 'styled-components'
import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { Z_INDEX_FOR_HIDE_REACT_SELECTO_RECTANGLE_DURING_SCROLL } from 'consts/zIndex'
import CrownSvg from 'assets/svgr-icons/Crown.svg'
import { OVERLAY_MAX_WIDTH } from 'consts/sidebar'

const blinkAnimation = keyframes`
  0% {
    background-color: transparent;
    box-shadow: none;
  }
  50% {
    background-color: rgba(56, 125, 255, 0.1);
    box-shadow: 0 0 12px rgba(56, 125, 255, 0.18);
  }
  100% {
    background-color: transparent;
    box-shadow: none;
  }
`

export const Container = styled.div`
  width: ${OVERLAY_MAX_WIDTH}px;
  height: 100%;
  border-right: 1px solid ${COLORS.borderColor};
  box-sizing: border-box;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  z-index: ${Z_INDEX_FOR_HIDE_REACT_SELECTO_RECTANGLE_DURING_SCROLL};
  background-color: ${COLORS.white};

  &[data-flash='1'] {
    animation: ${blinkAnimation} 1s ease-in-out;
  }

  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 100%;
    border-right: none;
    height: auto;
    flex: 1;
    min-height: 0;
  }
`

export const CrownIcon = styled(CrownSvg)`
  fill: ${COLORS.white};
`

export const premiumButtonStyles = css<{
  $isPremium: boolean
}>`
  ${({ $isPremium }) =>
    $isPremium &&
    css`
      background: linear-gradient(
        261.91deg,
        #2214e4 -3.09%,
        #d696ce 47.21%,
        #2f67fe 93.65%
      );

      &:hover {
        background: linear-gradient(
          261.91deg,
          #2f67fe -3.09%,
          #d696ce 43.34%,
          #2214e4 93.65%
        );
      }
    `}
`
